export default `
    <div id="#= data.id #" class="insert-object-group-container #= data.containerClasses || ""# #=data.bsc||""#" screenentitytype="#= data.ScreenEntityType #">
        <span  data-label-for-id="#= data.id #" class="insert-object-group-label bind-label" 
            #if(data.insertLabel){#
                data-bind="text:#= data.insertLabel#"
            #}#
        >
        </span>
        <div class="insert-object-group-contents">
            #= data.components #
        </div>
        <div id="#= data.id #_Container" class="insert-object-woop-container hidden">
            #= data.tabContainers #
        </div>
    </div>
`;
